import * as ActionTypes from '../actions/actionTypes';

const initialState = {};

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case ActionTypes.OPEN_MESSAGE:
      const openedState = { ...state };
      openedState[action.code] = { message: action.message, type: action.message_type };
      return openedState;

    case ActionTypes.CLOSE_MESSAGE:
      const closedState = { ...state };
      delete closedState[action.code];
      return closedState;

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/messages.js